import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
  FieldSelectYesNo,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectMaterialGroup,
  FormFieldMultiMaterialDlg,
} from 'shared-pages';
import { useRootStore } from 'store';
import { FieldSelectDocOptions } from 'shared-pages/components/select-dlg/fs-adr';
import { DocFilter, isRebatteryLiion, isRebattery } from 'shared-pages/common/constants';
import { buildWhereFromDocFilter } from 'shared-pages/common/filters-helpfunc';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ name: likeObj }, { phone: likeObj }, { adrNumber: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.isApproved !== undefined && values.isApproved !== null && values.isApproved !== '') {
      where = { ...where, isApproved: values.isApproved };
    }
    if (values.collectorId) where = { ...where, collectorId: values.collectorId };
    if (!!values.adr) where = buildWhereFromDocFilter(where, values.adr, 'adrNumber', 'adrExpDate');
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    adr: initialValues?.adr ?? undefined,
    isApproved: initialValues?.isApproved ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Ονοματεπώνυμο, Τηλέφωνο, ADR )')}
          type="search"
          disable={disable}
        />
        {!isGridInForm && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
        <FieldSelectDocOptions withBlank={false} label={t('ADR')} name="adr" as={FormCol} />
        {(isRebattery || isRebatteryLiion) && (
          <FieldSelectYesNo label={t('Εγκεκριμένοι')} disable={disable} name="isApproved" />
        )}
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};

